import React, { useState, useEffect, useContext } from "react"
import { Select } from "components-design-system"
import { EMA_RWD_OPTIONS_TYPE_MAP } from "constants/authoring"
// import { getEmaRwdOptions } from "../../../hooks/actions/useAuthoringActions"
import { useEmaRwdDropdowns } from "api/hooks/studies/useAuthoringApi"

// hoc
import InputWrapper from "../../hoc/InputWrapper/InputWrapper"

// api
import { useGetConditions } from "api/hooks/admin/useConditionApi"
import { useGetCollaboratorTypes } from "api/hooks/admin/useCollaboratorTypesApi"

const RJMultiselect = (props) => {
  let { id, carbonProps, value, options, onChange, invalid } = props
  const [items, setItems] = useState([])
  const { getEmaRwdOptions } = useEmaRwdDropdowns()
  const { data: conditions = [] } = useGetConditions()
  const { data: collaborators = [] } = useGetCollaboratorTypes()

  useEffect(() => {
    const getOptions = async () => {
      if (EMA_RWD_OPTIONS_TYPE_MAP[id]) {
        const items = await getEmaRwdOptions(id)
        setItems(items)
      } else if (props?.schema?.items?.options) {
        setItems(props.schema.items.options)
      } else if (props?.schema?.options) {
        setItems(props.schema.options)
      } else if (options && options.enumOptions) {
        let newItems = options.enumOptions.map((option) => {
          if (option.value) return option.value
          else if (typeof option === "string") return option
          else if (options.name) return option.name
        })
        setItems(newItems)
      }
    }

    getOptions()
  }, [])

  const onSetItems = (items) => {
    let newItems = items?.map((option) => {
      return { value: option.name, label: option.name }
    })
    setItems(newItems)
  }

  React.useEffect(() => {
    if (id === "root.protocol.study_description.study_conditions" && Array.isArray(conditions)) {
      onSetItems(conditions)
    }
  }, [conditions])

  React.useEffect(() => {
    if (id === "root.protocol.contact_information.collaborators" && Array.isArray(collaborators)) {
      onSetItems(collaborators)
    }
  }, [collaborators])

  const handleChange = (val) => {
    console.log("Multi useEffect >> onChange")
    onChange(val)
  }

  const variant = invalid ? "error" : undefined

  return (
    <Select
      id={id + "-field"}
      mode="multiple"
      allowClear
      disabled={carbonProps?.disabled}
      status={variant}
      placeholder="Please select"
      defaultValue={Array.isArray(value) ? value : []}
      onChange={handleChange}
      options={items || []}
    />
  )
}

export default InputWrapper(RJMultiselect)
